import React, { useState } from "react";
import { Icon, Spinner } from "@shopify/polaris";
// import { AiOutlineClose } from "react-icons/ai";
import "../Assets/Styles/sliding-panel.css";
import { ExitMajor } from "@shopify/polaris-icons";
import {
  AiOutlineClose,
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
} from "react-icons/ai";
import { useEffect } from "react";
import { SectionCollapse } from "./SectionCollapse";

const SlidingPanel = ({
  title,
  isOpen,
  togglePanel,
  id,
  handleRefresh,
  handlePrevious,
  handleNext,
  openState,
  type,
  object,
  languagesArray,
  pagesArray,
  blogsArray,
  menusArray,
  sectionId,
  handleSaveAndRefresh,
  handleSaveWithoutRefresh,
  isSaving,
  handleSavingState,
  handleDeleteAndRefresh,
  handleRefreshSections,
  changeOpenValue,
  urlType,
  handleResetSavingState,
  handleShowDeleteModal,
  collectionsArray,
  productsArray,
  channels,
  templates,
  shopifyDomainFound,
  refreshApi,
  isOpeningSlider = { isOpeningSlider },
}) => {
  return (
    <>
      {/* <Button onClick={togglePanel}>
        {isOpen ? "Close Panel" : "Open Panel"}
      </Button> */}

      <div className={`panel ${isOpen ? "open" : ""}`}>
        <div className="panel-header">
          {/* <div className="header-buttons">
            <AiOutlineArrowLeft className="nav-icon" onClick={handlePrevious} />
            <AiOutlineArrowRight className="nav-icon" onClick={handleNext} />
          </div> */}
          <h2>{title}</h2>
          <div style={{ cursor: "pointer" }} onClick={() => togglePanel(false)}>
            {/* <Icon source={ExitMajor}></Icon> */}
            <AiOutlineClose
              className="close-icon"
              onClick={() => togglePanel(false)}
            />
          </div>
          {/* <AiOutlineClose
            className="close-icon"
            onClick={() => togglePanel(false)}
          /> */}
        </div>
        <div className="panel-content">
          {!isOpeningSlider ? (
            <SectionCollapse
              id={id}
              //updateOpenArrayStateClose={updateOpenArrayStateClose}

              //previewState={previewState}
              // dragHandleProps={{
              //   ...provided.dragHandleProps,
              // }}
              // key={idx}
              type={JSON.parse(object).section_type}
              title={``}
              object={object}
              languagesArray={languagesArray}
              pagesArray={pagesArray}
              blogsArray={blogsArray}
              menusArray={menusArray}
              sectionId={sectionId}
              // lastElememtId={lastElememtId}
              handleSaveAndRefresh={handleSaveAndRefresh}
              handleSaveWithoutRefresh={handleSaveWithoutRefresh}
              isSaving={isSaving}
              handleSavingState={handleSavingState}
              handleDeleteAndRefresh={handleDeleteAndRefresh}
              handleRefreshSections={handleRefreshSections}
              changeOpenValue={changeOpenValue}
              urlType={urlType}
              handleResetSavingState={handleResetSavingState}
              handleShowDeleteModal={handleShowDeleteModal}
              collectionsArray={collectionsArray}
              productsArray={productsArray}
              channels={channels}
              templates={templates}
              shopifyDomainFound={shopifyDomainFound}
              openState={true}
              refreshApi={refreshApi}
            />
          ) : (
            <div className="spinnerContainer">
              <div className="vertical-center">
                <Spinner size="large" />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SlidingPanel;
